import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

export const HeaderContainer = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 100px;
  background-color: #fff;
  position: relative;
  z-index: 1000;
  font-size: 20px;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

export const Logo = styled.img`
  height: 36px;
`;

export const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: 3rem;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const NavLinkStyled = styled(NavLink)<{isActive?: boolean}>`
  color: #000000;
  text-decoration: none;
  font-weight: ${({isActive}) => isActive ? 700 : 300};
`;

export const Button = styled.button`
  padding: 12px 24px;
  background: #F7931E;
  color: white;
  border: none;
  border-radius: 14px;
  cursor: pointer;
  font-weight: 600;
  font-size: 20px;

  &:hover {
    background: #ee7e31;
  }
`;

export const HamburgerIcon = styled.div`
  font-size: 1.5rem;
  cursor: pointer;
  display: none;

  @media (max-width: 768px) {
    display: block;
  }
`;

export const MobileMenu = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 80%;
  height: 100vh;
  background: #fff;
  padding: 2rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  z-index: 1200;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
`;

export const CloseButton = styled.div`
  font-size: 2rem;
  align-self: flex-end;
  cursor: pointer;
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(128, 128, 128, 0.4);
  z-index: 1100;
`;
